import { mapActions, mapMutations } from 'vuex'

import { COOKIE_ENTITY_TYPE } from 'enums/oneTrust'
import oneTrust from '@/utils/mixins/one-trust'
import * as types from '@/store/mutation-types'
import {
  DISQUS_SCRIPT_IDENTIFY_STRING,
  REFRESH_COMMENT_COUNT_VALUE_INTERVAL,
  UPDATE_COMMENT_COUNT_EVENT
} from 'shared/AActionIcon/_shared/CommentCount/enums'
import { createOneTrustHandlerInstance } from 'enums/oneTrust/one-trust-handler'

export default () => ({
  mixins: [oneTrust],
  data() {
    return {
      clearRequestCommentCountValueInterval: () => {}
    }
  },
  methods: {
    ...mapMutations({
      $_disqusCommentCount_setDisqusWidgetLoadStatus:
        types.SET_DISQUS_WIDGET_LOAD_STATUS
    }),
    ...mapActions({
      registerHandlerThatRequiresConsent:
        'one-trust/registerHandlerThatRequiresConsent'
    }),
    $_disqusCommentCount_initDisqusWidget() {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.onload = this.$_disqusCommentCount_onCommentCountWidgetLoad
      script.id = 'dsq-count-scr'
      script.src = `//${this.$env.FM_DISQUS_SHORT_NAME}.disqus.com/count.js`
      this.$helper.insertScriptToHead(script)
    },
    /**
     * Unfortunately Disqus doesn't support SPA and doesn't support multiple
     * accounts within the same site.
     * When we initialize disqus script, we configure it for some account.
     * To switch to another account (and initiate update scripts with the proper
     * disqus domain) we found an undocumented solution to update forum value in
     * DISQUSWIDGETS object in window. After this change all further requests
     * to update comment counts will use updated forum name in script path.
     */
    $_disqusCommentCount_updateShortNameForExistingDisqus() {
      window.DISQUSWIDGETS.forum = this.$env.FM_DISQUS_SHORT_NAME
    },
    $_disqusCommentCount_onCommentCountWidgetLoad() {
      if (window.DISQUSWIDGETS) {
        this.$_disqusCommentCount_setDisqusWidgetLoadStatus(true)
        this.$_disqusCommentCount_refreshCommentCountValue()
      }
    },
    $_disqusCommentCount_refreshAllVisibleDisqusCommentCounts() {
      if (window && window.DISQUSWIDGETS) {
        window.DISQUSWIDGETS.getCount({ reset: true })
        this.$_disqusCommentCount_removeDisqusScriptsFromHead()
      }
    },
    $_disqusCommentCount_removeDisqusScriptsFromHead() {
      try {
        const head = document.head

        const disqusScriptsInHead = [...head.children].filter(
          (el, index) =>
            el.tagName === 'SCRIPT' &&
            (el?.src || '').includes(DISQUS_SCRIPT_IDENTIFY_STRING)
        )
        disqusScriptsInHead.forEach(script => head.removeChild(script))
      } catch (err) {
        this.$errorHandler(err, this, { showMessage: false })
      }
    },
    $_disqusCommentCount_refreshCommentCountValue() {
      const { clearInterval } = this.$helper.runWithInterval(
        this.$_disqusCommentCount_updateCommentCounts,
        REFRESH_COMMENT_COUNT_VALUE_INTERVAL
      )

      this.clearRequestCommentCountValueInterval = clearInterval
    },
    $_disqusCommentCount_updateCommentCounts() {
      this.$_disqusCommentCount_refreshAllVisibleDisqusCommentCounts()
      this.$_disqusCommentCount_emitUpdateCommentCountEvent()
    },
    $_disqusCommentCount_emitUpdateCommentCountEvent() {
      this.$bus.$emit(UPDATE_COMMENT_COUNT_EVENT)
    },
    $_disqusCommentCount_init() {
      if (!window.DISQUSWIDGETS) {
        this.$_disqusCommentCount_initDisqusWidget()
        return
      }

      if (window.DISQUSWIDGETS?.forum !== this.$env.FM_DISQUS_SHORT_NAME) {
        this.$_disqusCommentCount_updateShortNameForExistingDisqus()
      }

      this.$_disqusCommentCount_refreshCommentCountValue()
    }
  },
  mounted() {
    if (!this.$env.FM_DISQUS_SHORT_NAME) {
      return
    }

    this.registerHandlerThatRequiresConsent(
      createOneTrustHandlerInstance({
        handler: this.$_disqusCommentCount_init,
        entityType: COOKIE_ENTITY_TYPE.DISQUS
      })
    )
  },
  beforeDestroy() {
    this.clearRequestCommentCountValueInterval()
  }
})
